module.exports = __webpack_public_path__ + "static/Sequence_Activate_Homepage-4f70228bf22852a0ef48b7aaba242b61.mp4";